export default class PhysicianDemographicModel {
    constructor()
    {
        this.races = [];
    }

    physicianDemographicId? : number
    personKey? : number
    ethnicity? : number
    gender? : number
    races? : Array<PhysicianDemographicRaceModel>
}

export class PhysicianDemographicRaceModel {
    physicianDemographicRaceId? : number
    physicianDemographicId? : number
    race? : number
}

export enum EthnicityType
{
    HispanicOrLatinoa = 1,
    NonHispanicOrNonLatinoa = 2,
    Other = 3,
    NoAnswer = 4
}

export enum GenderType
{
    Female = 1,
    Male = 2,
    NonBinary = 3,
    Other = 4,
    NoAnswer = 5
}